<div *ngIf="hasNotesPermission" class="note-section">
    <div class="add-note-box">
        <p class="heading">
            Notes
        </p>
        <button class="add-btn" (click)="addNote()">
            <span class="icon">
                <img src="../../../../../assets/images/add-noteicon.svg" alt="Add note" />
            </span>
            <span class="text">
                Add Note
            </span>

        </button>
    </div>
    <div class="note-details-box" *ngFor="let note of driverNotesHistory">
        <div class="date-time-box">
            <p class="inner-text">
                {{note?.dateCreated}}
            </p>
        </div>
        <div class="category-box">
            <div class="icon-box">
                <img [src]="eventTitle(note).iconPath" alt=""/>
            </div>
            <p class="inner-text">
                {{eventTitle(note).title}}
            </p>
        </div>
        <div class="detail-box">
            <div class="line-box">
                <div class="line"></div>
            </div>
            <div   class="details">
                <div>
                    {{(note.eventName !== 4) ? "Generated automatically by the system" : note.notes}} -
                    <span>
                        {{note.eventCreatedBy}}
                    </span>
                </div>
                <div *ngIf="(note.eventName === 4  && note.isDeleted)" class="export-btn">
                    <img (click)="activeItem;showData(note.id,$event);menu.toggle($event)" src="assets/images/dashboard-dot.svg"
                        alt="" />
                </div>
            </div>
        </div>

    </div>

    <div *ngIf="driverNotesHistory?.length === 0" class="no-notes">
            <p class="no-notes-text">No Notes added yet!</p>
    </div>
    <div class="custom-export"> <p-menu #menu [model]="items" [popup]="true"></p-menu>
    </div>
</div>